import initTooltips from "../../component/Tooltip";

/**
 * This class finds instances of terms in our glossary  in the content of the page
 * and prepares HTML.
 * A separate Tooltip component adds the actual tooltip.
 */
export default class DynamicTooltipMaker {
	public static hasTooltipStyleClass = "hasTooltip";

	// Glossary
	private glossary: any;
	private glossaryRegExps: any = {};

	public constructor(elementContainerQuery: string, glossaryUrl: string) {
		this.processNode = this.processNode.bind(this);
		this.findTerms = this.findTerms.bind(this);

		
		if (glossaryUrl.indexOf("://") === -1) {
			const baseTags = document.getElementsByTagName("base");
			let baseUrl = baseTags.length ? baseTags[0].href : document.URL;
			if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
				baseUrl = baseUrl + "/";
			}
			glossaryUrl = baseUrl + glossaryUrl;
		}


		const xhr = new XMLHttpRequest();
		xhr.open("GET", glossaryUrl, true);
		xhr.responseType = "json";
		xhr.onload = (ev: ProgressEvent) => {
			if (xhr.status === 200) {
				this.glossary = xhr.response;
				this.findTerms(elementContainerQuery);
				initTooltips();
			}
		};
		xhr.send();
	}

	private findTerms(elementContainerQuery: string) {
		// Search and Replace
		const conainerElems = document.querySelectorAll(elementContainerQuery);
		for (let i = 0; i < conainerElems.length; i++) {
			const containerElem = conainerElems[i];

			// Find all descendent Elements with a query and then get all children, and then add the children of the initial
			// The result is an array of lists
			const arrayOfChildNodes: any[] = Array.prototype.map.call( // Using Array.prototype here and later to support IE11 which does not have .forEach() on NodeListOf<>
				containerElem.querySelectorAll(`*:not(.${DynamicTooltipMaker.hasTooltipStyleClass})`),
				(elem: Element) => elem.childNodes
			);
			arrayOfChildNodes.push(containerElem.childNodes);

			// Process each entry
			arrayOfChildNodes.forEach(
				(nodes: any) => {
					for (let n = 0; n < nodes.length; n++) {
						this.processNode(nodes[n]);
					}
				}
			);
			
		}
	}

	private processNode(node: Node) {
		if (node.nodeType == Node.TEXT_NODE) {
			// Search for each word and put definitions in place
			let newValue = node.nodeValue;
			for (const word in this.glossary) {
				newValue = newValue.replace(
					this.glossaryRegExps[word] ?? (this.glossaryRegExps[word] = new RegExp("\\b" + word + "\\b", 'gi')), // Store the reg exp on glossary.
					`<span class="${DynamicTooltipMaker.hasTooltipStyleClass}" title="${this.glossary[word]}">${word}</span>`
				);
			}
			// If there was a change update the HTML
			// We must create a temporary element to render the HTML in.
			// We then move all the childnren to where the original text node
			// was, and finally remove the orignal node.
			if (newValue.length !== node.nodeValue.length) {
				const parent = node.parentNode;
				const newNode = document.createElement("span");
				newNode.innerHTML = newValue;
				while (newNode.firstChild) {
					parent.insertBefore(newNode.firstChild, node);
				}
				parent.removeChild(node);
			}
		}
	}
}
